import React from 'react';
import styled, { css, DefaultTheme } from 'styled-components';
import { hexToRGBA } from 'src/utils/hex-to-rgba';
import { Flex } from 'src/packages/core';
import { BadgeType } from './Badge.types';

export const getBadgeStyles = (type: BadgeType, theme: DefaultTheme) => {
  switch (type) {
    case 'error':
      return css`
        background: ${hexToRGBA(theme.colors.palette.red, 0.15)};
        color: ${theme.colors.text.primary};

        svg path {
          fill: ${theme.colors.palette.red};
        }
      `;
    case 'success':
      return css`
        background: ${hexToRGBA(theme.colors.palette.green, 0.15)};
        color: ${theme.colors.text.primary};

        svg path {
          fill: ${theme.colors.palette.green};
        }
      `;
    case 'pending':
      return css`
        background: ${hexToRGBA(theme.colors.palette.orange, 0.15)};
        color: ${theme.colors.text.primary};

        svg path {
          fill: ${theme.colors.palette.orange};
        }
      `;
    case 'info':
      return css`
        background: ${hexToRGBA(theme.colors.palette.blue, 0.15)};
        color: ${theme.colors.text.primary};

        svg path {
          fill: ${theme.colors.palette.blue};
        }
      `;
  }
};

export const BadgeContainer = styled((props) => <Flex {...props} />)<{
  // eslint-disable-next-line
  badgeStyles: any;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: fit-content;
  height: auto;
  padding: 6px;
  border-radius: 4px;
  ${(props) => props.badgeStyles};
`;
